import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-path-fk',
  templateUrl: './path-fk.component.html',
  styleUrls: ['./path-fk.component.css']
})
export class PathFKComponent implements OnInit {

 @Input() userPathFK: any;
 percent6: string;
 percent9: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    if(this.userPathFK.sales != undefined){
      if(this.userPathFK.sales[0].new_business_nsz_count != null){
        let num6 = 0;
        let num9 = 0;
        if(this.userPathFK.sales[0].new_business_nsz_count <= 6){
          num6 = (this.userPathFK.sales[0].new_business_nsz_count / 6) * 100;
        }
        else{
          num6 = 100;
        }
        if(this.userPathFK.sales[0].new_business_nsz_count <= 9){
          num9 = (this.userPathFK.sales[0].new_business_nsz_count / 9) * 100;
        }
        else{
          num9 = 100;
        }
        this.percent6 = num6 + '%';
        this.percent9 = num9 + '%';
      }
    }
  }

}
